import HorizontalImageSplitHero from './HorizontalImageSplitHero';

export { type HorizontalImageSplitHeroProps } from './HorizontalImageSplitHero';
export default HorizontalImageSplitHero;
